module.exports = __webpack_public_path__ + "static/media/user-default.bd4a5895.png";